module.exports = __webpack_public_path__ + "img/UN_Women_Spurning07.d777f181.gif";